<header>
  <div class="wrap">
    <div class="text">
      <h2 class="title">{{ 'popins.closet-doors-percentage.title' | translate }}</h2>
      <p class="my-5">
        {{
          'popins.closet-doors-percentage.p1' | translate: { doorNumber: doorNumber, doorPercentage: neededPercentage }
        }}
      </p>
      <p class="my-5">{{ 'popins.closet-doors-percentage.p2' | translate: { doorPercentage: openingPercentage } }}</p>
    </div>
    <div class="header-actions">
      <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>
  </div>
</header>
<div class="main">
  <footer class="popin-footer">
    <ng-casto-btn
      class="blue"
      [label]="'popins.closet-doors-percentage.confirm' | translate"
      (click)="modalService.close()"></ng-casto-btn>
  </footer>
</div>
